import { Constants } from 'config/constants'

export class AppHtmlContent {
  static buildPreview(content: string): string {
    return `
      <!DOCTYPE html>
      <html>
      <head>
        <meta charset="utf-8">
        <link rel="stylesheet" href="/assets/tinymce/contents.css?t=${Constants.CKEDITOR_ASSETS_VERSION}">
      </head>
      <body>${content || ''}</body>
      </html>
    `
  }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/core/app-html-content.ts